import React, { createContext, useContext, useEffect, useState } from "react";
import { callGetBonusOfferings } from "repoV2/pages/brandedCommunity/utils/apis";
import { logError } from "repoV2/utils/common/error/error";
import { useEventDataOfSelectedEvent } from "@Utils/event";
import { IBrandedCommunity } from "repoV2/pages/brandedCommunity/IBrandedCommunity";
import { LISTING_TYPES } from "repoV2/constants/listing";

interface BonusOfferingContextProps {
    bonusOfferings: Array<IBrandedCommunity.ICommunityOffering>;
}

const initialContextValue: BonusOfferingContextProps = {
    bonusOfferings: [],
};

const BonusOfferingContext =
    createContext<BonusOfferingContextProps>(initialContextValue);

export function BonusOfferingContextProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const [bonusOfferings, setBonusOfferings] = useState<
        Array<IBrandedCommunity.ICommunityOffering>
    >([]);

    const { eventData } = useEventDataOfSelectedEvent();

    const getBonusOfferings = async () => {
        if (eventData.type !== LISTING_TYPES.BRANDED_COMMUNITY) return;
        try {
            const response = await callGetBonusOfferings({
                community_listing_id: eventData.uuid,
            });
            if (response.offerings) setBonusOfferings(response.offerings);
        } catch (e) {
            logError({
                error: e,
                occuredAt: "getInitialProps in pages/evebt/index",
                when: "calling callApiforBonusOfferings",
            });
        }
    };

    useEffect(() => {
        getBonusOfferings();
    }, [eventData.uuid]); // on switching plan, new bonus offerings should be fetched

    const contextValue: BonusOfferingContextProps = {
        bonusOfferings,
    };

    return (
        <BonusOfferingContext.Provider value={contextValue}>
            {children}
        </BonusOfferingContext.Provider>
    );
}

export function useBonusOfferingContext() {
    return useContext(BonusOfferingContext);
}
